import "./changePassword.scss";
import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "../../../../store/reducers/reducerUser";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../../../i18n/LangContext";

const ChangePassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { t } = useLang();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const scrollTargetRef = useRef(null);
  useEffect(() => {
    const yOffset = -120;
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("❌ Please enter a valid email address.");
      return;
    }

    if (newPassword.length < 6) {
      setMessage("❌ Password must be at least 6 characters.");
      return;
    }

    if (newPassword.length > 10) {
      setMessage("❌ Password cannot be more than 10 characters.");
      return;
    }

    if (/\s/.test(newPassword)) {
      setMessage("❌ Password cannot contain spaces.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    setLoading(true);

    const actionResult = await dispatch(changePassword({ email, newPassword }));

    if (changePassword.fulfilled.match(actionResult)) {
      setMessage("✅ Password updated successfully");
      setEmail("");
      setNewPassword("");
      setConfirmPassword("");

      setTimeout(() => {
        setLoading(false);
        navigate(-1);
      }, 1000);

      return;
    }

    if (changePassword.rejected.match(actionResult)) {
      const errorPayload = actionResult.payload;
      const msg =
        (typeof errorPayload === "string" && errorPayload) ||
        errorPayload?.error ||
        "❌ Failed to change password";

      setMessage(msg);
    }

    setLoading(false);
  };

  return (
    <div className="changePasswordContainer">
      <h2 ref={scrollTargetRef}>{t("change_password")}</h2>
      <form onSubmit={handleSubmit} className="changePasswordForm">
        <input
          type="email"
          placeholder={t("your_email")}
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder={t("new_password")}
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder={t("confirm_new_password")}
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <div className="changePasswordActions">
          <button type="submit" disabled={loading}>
            {loading ? t("updating") : t("update")}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="cancelBtn"
          >
            {t("cancel")}
          </button>
        </div>
      </form>
      {message && <div className="changePasswordMessage">{message}</div>}
    </div>
  );
};

export default ChangePassword;
